export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-carved-in-stone-50a8cea8134dc828acef62a7c249cc2d.jpg";